export default __webpack_public_path__ + "static/media/hammer-1.0147dfea.png";